import * as Intro from 'src/styles/views/intro'

export const FooterContent = () => {
  return (
    <Intro.FooterContentWrap>
      <Intro.FooterContentLayout>
        <Intro.FooterContentTitle>기타 안내사항</Intro.FooterContentTitle>
        <Intro.FooterContentNotiWrap>
          <Intro.FooterContentNoti>
            본 서비스는 가입 즉시 서비스가 개시되는 상품이므로 청약철회 및 환불이 불가능합니다.
            (전자상거래 등에서의 소비자보호에 관한 법류 제17조 2항 5호에 따라 디지털 콘텐츠의 제공이
            개시된 경우 청약철회를 제공하지 않습니다.)
          </Intro.FooterContentNoti>
          <Intro.FooterContentNoti>
            본 서비스는 (주)데이터유니버스에서 운영합니다.
          </Intro.FooterContentNoti>
          <Intro.FooterContentNoti>
            안드로이드 5.0 이상/iOS 14 이상을 지원하지 않는 단말기 및 피처폰 고객은 서비스 이용이
            불가합니다.
          </Intro.FooterContentNoti>
          <Intro.FooterContentNoti>
            서비스를 이용할 때 가입한 요금제에 따라 데이터 요금이 발생할 수 있습니다.
          </Intro.FooterContentNoti>
          <Intro.FooterContentNoti>
            피싱해킹보상보험은 가입 다음날 0시부터 제공되며, 자기부담금 60만원(1회 사고당)이
            발생합니다. 해당 보험은 1인 1사고당 보험한도액 300만원 내 보상하며, 증권상 최대
            보상한도액 초과 시 보험금이 지급되지 않을 수 있습니다.
          </Intro.FooterContentNoti> 
          <Intro.FooterContentNoti>
            서비스 홈페이지 https://www.antiscam.co.kr
          </Intro.FooterContentNoti>
          <Intro.FooterContentNoti>
            서비스 가입/해지/이용문의 : 1811-7531, cs@datau.co.kr
          </Intro.FooterContentNoti>
        </Intro.FooterContentNotiWrap>
      </Intro.FooterContentLayout>
    </Intro.FooterContentWrap>
  )
}
